import { Modal } from 'react-bootstrap';
import { Input } from '../../../common/Forms/Input/Input';
import { ActionButton, DisabledButton } from '../../../common/Buttons/Buttons';
import '../../../common/Modals/Modals.scss';

export const TransferToIntermediaryModal = (props) => {
  const {
    show,
    handleModal,
    membership,
    register,
    sellerOptions,
    saleChannelOptions,
    watch,
    onConfirmTransfer,
  } = props;


  return (
    <Modal centered show={show} onHide={() => handleModal(false)} size="lg">
      <Modal.Header closeButton className="modal-header">
        <div className="intermediary-modal-header">
          <h5>Pasar orden a intermediario</h5>
          <p>
            Orden #{membership?.orderNumber || membership?.membershipId || '-'} · Canal
            origen: {saleChannelOptions?.find((channel) => channel?._id === membership?.saleChannel)?.name || '-'}
          </p>
        </div>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <div className="intermediary-modal-content">
          <div className="intermediary-modal-warning">
            <h6>Atención: orden de canal interno</h6>
            <p>
              Al asignar a un intermediario, la comisión aplicada será reducida según
              política de canal cruzado.
            </p>
          </div>

          <h6 className="intermediary-modal-section-title">SELECCIONAR INTERMEDIARIO</h6>
          <Input
            bootstrap={'col-12'}
            label={'Asesor / intermediario responsable *'}
            type={'select'}
            name={'transferTo'}
            options={sellerOptions}
            register={register}
            placeholder={''}
            errors={''}
          />
        </div>
      </Modal.Body>
      <div className="buttons-center-container">
        {watch('transferTo') ?
          <ActionButton label={'Confirmar'} action={onConfirmTransfer} />
          : <DisabledButton label={'Confirmar'} action={() => { }} />}
      </div>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};
